import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { PostsComponent } from '../components/chapters.component';
import { selectTopicsQueryItems } from '../../../../../../redux/chapter/topics/selector';
import { chapter } from '../../../../../../redux/chapter/chapters/action';
import { selectChapterListItems, selectChapterQueryItems } from '../../../../../../redux/chapter/chapters/selector';
import { selectListItems } from '../../../../../../redux/library/selector';
import { chapterPost } from '../../../../../../redux/chapter/posts/action';
import { communities } from '../../../../../../redux/community/action';
import { selectCommunitiesListItems } from '../../../../../../redux/community/selector';
import { settings } from '../../../../../../redux/settings/actions';
import UploadFiles from '../../../../../../models/UploadFile';
import { selectCurrent } from '../../../../../../redux/settings/selectors';

const Chapter = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const parmas: any = useParams();
  const topicsQuery = useSelector(selectChapterQueryItems);
  const chaptersItems = useSelector(selectCommunitiesListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [mediaFiles, setMediaFiles] = useState<any>([])
  const libraryData = useSelector(selectListItems)
  const [openConfirmationLogoFile, setOpenConfirmationLogoFile] = React.useState(false);
  const [openConfirmationCoverFile, setOpenConfirmationCoverFile] = React.useState(false);
  const [openImageFile, setOpenImageFile] = useState<any>([]);
  const { getUploadFiles } = useAppSelector(selectCurrent)

 const handleClose = () => {
      if (openConfirmationLogoFile) {
        setOpenConfirmationLogoFile(false)
    }else if(openConfirmationCoverFile){
      setOpenConfirmationCoverFile(false)
    }
        dispatch(settings.set({ getUploadFiles: 'close' }))
        
      }

  const [selectedChapters, setSelectedChapters] = useState<any>({
    "Name": "",
    "DisplayOrder": 0,
    "CommunityId": 0

  });

  const fetchForumGroupsQueryById = () => {
    dispatch(chapter.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapters/query`,
      entity: 'chapter',
      jsonData: {
        Context: {},
        Records: [
          {

            Id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true);
    });
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedChapters({ ...selectedChapters, [field]: event });
  }
  const handleFormMediaItemChange: any = ({ value }: any) => {
    setMediaFiles(value);
  }
  useEffect(() => {
    dispatch(communities.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/communities/list`,
      entity: 'communities',
      jsonData: {

        "Context": {
          "Subscription": "ONE",
          "Domain": "ONE",
          "SubDomains": [],
          "Network": "Internal",
          "Application": "Management",
          "Channel": "Portal"
        },
        "Records": [
          {
            "Id": 0
          }
        ],
        "Pagination": {
          "PageNumber": 1,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc"
        }

      }
    })).then(() => {
      if (parmas?.id > 0) {
        fetchForumGroupsQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, []);

  useEffect(() => {
    if (isQuery) {
      setSelectedChapters(topicsQuery?.result?.items);
    }
  }, [isQuery]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )

    const ChaptersData = {
      "Id": 1,
      "CommunityId": selectedChapters?.CommunityId,
      "Name": selectedChapters?.Name,
      "Description": selectedChapters?.Description,
      "DisplayOrder": selectedChapters?.DisplayOrder,
      "Location": selectedChapters?.Location,
      "LogoUrl": selectedChapters?.LogoUrl,
      "CoverImageUrl": selectedChapters?.CoverImageUrl,
      "MediaMappings": {
        "MediaFiles": [],
        "Templates": []
      },

    }
    if (parmas?.id > 0) {
      await dispatch(chapter.resetAction({ actionType: 'update' }))
      await dispatch(chapter.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapters`,
        entity: 'chapter',
        jsonData: {
          Context: {},
          Records: [
            ChaptersData
          ]

        }
      })).then(() => {
        back();
      });
    } else {
      await dispatch(chapter.resetAction({ actionType: 'create' }))
      await dispatch(chapter.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapters`,
        entity: 'chapter',
        jsonData: {
          Context: {},
          Records: [
            ChaptersData
          ]
        }
      })).then(() => {
        back();
      });
    }
  }

  const back = () => {
    navigate('/management/onesp/chapters/chapter');
  }

  const changeLogoImage = (templateField: any, fileType: any, selectedCommunity: any) => {
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenConfirmationLogoFile(true)
    setOpenImageFile({
      currentFileSrc: selectedCommunity?.LogoUrl || templateField,
      folder: 'communitychapter',
      type: fileType
    })
  }

  const changeCoverImage = (templateField: any, fileType: any, selectedCommunity: any) => {
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenConfirmationCoverFile(true)
    setOpenImageFile({
      currentFileSrc: selectedCommunity?.CoverImageUrl || templateField,
      folder: 'communitychapter',
      type: fileType
    })
  }

  const handleLogoSubmit = (data: any) => {
    const logoData = {
      LogoUrl: data
    }
    setSelectedChapters({ ...selectedChapters, ...logoData })
  }

  const handleCoverSubmit = (data: any) => {
    const coverImageUrl = {
      CoverImageUrl: data
    }
    setSelectedChapters({ ...selectedChapters, ...coverImageUrl })
  }


  return (

    <>

      {getUploadFiles == 'open' && openConfirmationLogoFile &&
        <UploadFiles currentFilesSrc={openImageFile?.currentFileSrc}
          folder={openImageFile?.folder}
          handleClose={handleClose}
          handleFilesSubmit={handleLogoSubmit}
          type={openImageFile?.type}
          ownerId={parmas?.id}
        />
      }

      {getUploadFiles == 'open' && openConfirmationCoverFile &&
        <UploadFiles currentFilesSrc={openImageFile?.currentFileSrc}
          folder={openImageFile?.folder}
          handleClose={handleClose}
          handleFilesSubmit={handleCoverSubmit}
          type={openImageFile?.type}
          ownerId={parmas?.id}
        />
      }

      {topicsQuery?.isLoading ? <PageLoader /> :
        <PostsComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedChapters={selectedChapters}
          back={back}
          handleFormSubmit={handleFormSubmit}
          chapters={chaptersItems?.result?.items}
          onFormItemChange={handleFormMediaItemChange}
          id={parmas?.id}
          libraryData={libraryData?.result?.ChapterTopicType}
          changeLogoImage={changeLogoImage}
          changeCoverImage={changeCoverImage}
        />
      }
    </>
  );
}

export default Chapter;
